const SITE_CODES = {
    MOSCOW: "moskvaonline",
    MAIN: "101internet",
    PITER: "piteronline",
};

const PHONE_NUMBER_BY_CODE = {
    [SITE_CODES.MOSCOW]: "+7 (495) 256-00-21",
    [SITE_CODES.MAIN]: "+7 800 302-32-76",
    [SITE_CODES.PITER]: "+7 (812) 385-66-34",
};

export const isMoscowSiteCode = code => SITE_CODES.MOSCOW === code;
export const isMainSiteCode = code => SITE_CODES.MAIN === code;
export const isPiterSiteCode = code => SITE_CODES.PITER === code;

export const getPhoneNumberByCode = code =>
    PHONE_NUMBER_BY_CODE[code] || PHONE_NUMBER_BY_CODE[[SITE_CODES.MOSCOW]];
